<template>
  <FormWrapper
    wrapperClass="margin-top-16"
    bodyClass="padding-x-16 padding-top-16"
    :handleSubmit="handleSubmit"
    :loading="loading"
  >
    <Dropdown
      :title="$lang.select_user"
      :label="$lang.select_user"
      :placeholder="$lang.select_user"
      :infoTooltip="$lang.add_cooperator_parvandeh_alert"
      :value="form.userSelected"
      name="userSelected"
      id="userSelected"
      :vuelidateObj="$v.form.userSelected"
      :options="userOptions"
      :loading="userLoading"
      :asyncSearch="getUserOptions"
      @input="input"
      @focus="resetValidation"
      @blur="checkValidation"
    />
    <Dropdown
      :title="$lang.select_term"
      :label="$lang.select_term"
      :placeholder="$lang.select_term"
      :value="form.termSelected"
      name="termSelected"
      id="termSelected"
      :vuelidateObj="$v.form.termSelected"
      :asyncSearch="getTermOptions"
      :insideFeature="true"
      @input="input"
      @focus="resetValidation"
      @blur="checkValidation"
    />
    <Input
      :title="$lang.description"
      :label="$lang.description"
      :placeholder="$lang.description"
      :value="form.description"
      name="description"
      id="description"
      type="textarea"
      :minLength="lengthNumber3"
      :maxLength="lengthNumber256"
      :vuelidateObj="$v.form.description"
      :hasLeftIcon="true"
      @input="input"
      @focus="resetValidation"
      @blur="checkValidation"
    />
  </FormWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { FormWrapper, Dropdown, Input } from "@/components/re-design/forms";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateError, goToRoute } from "@/shared/utils";
import { getUserCombo, getTermCombo } from "@/services";
import { addManualParvandehForActiveUser } from "@/modules/profile/services";

export default {
  mixins: [inputMixin],
  components: { FormWrapper, Dropdown, Input },
  validations() {
    return {
      form: {
        userSelected: {
          required,
        },
        termSelected: {
          required,
        },
        description: {
          minLength: minLength(this.lengthNumber3),
          maxLength: maxLength(this.lengthNumber256),
        },
      },
    };
  },
  data() {
    return {
      loading: false,
      form: {
        userSelected: null,
        termSelected: null,
        description: null,
      },
      userOptions: [],
      userLoading: false,
      termOptions: [],
      termLoading: false,
    };
  },
  methods: {
    goToRoute,
    async getUserOptions(text) {
      this.userOptions = [];
      try {
        this.userLoading = true;
        const response = await getUserCombo(text);
        const { options } = response;
        this.userOptions = options;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.userLoading = false;
      }
    },
    async getTermOptions(text = null) {
      try {
        const response = await getTermCombo(text);
        const { options } = response;
        return options;
      } catch (error) {
        generateError(error);
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const userCode = pathOr(null, ["id"], this.form.userSelected);
        const termCode = pathOr(null, ["id"], this.form.termSelected);
        const description = this.form.description;
        const response = await addManualParvandehForActiveUser(
          userCode,
          termCode,
          description
        );
        const { message } = response;
        this.$notify.success(message);
        this.backToParvandehList();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    backToParvandehList() {
      goToRoute("parvandeh", {}, {}, false);
    },
  },
};
</script>
